const html = require('choo/html')
const requestMic = require('./utility/requestMic.js')

module.exports = function store(state, emitter) {
  state.tutorialSteps = []

  emitter.on('starttutorial', () => {
    console.log('starttutorial')
    state.isSoundLibraryOpen = false
    state.isRecordingOpen = false
    state.tutorialSteps = [
      {
        position: ['top', 'right'],
        message: "Click on the sample pads or use your keyboard or Makey Makey to trigger sounds.",
        el: '#sampler-board #grid',
        onComplete: () => {
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      },
      {
        position: ['top', 'right'],
        message: "Change the sample packs to try new sounds.",
        el: '#sample-packs'
      },
      {
        position: ['top', 'right'],
        message: "Or choose sounds from the library.",
        el: '#sampler-board #open-library',
        onComplete: () => {
          state.isSoundLibraryOpen = true
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      },
      {
        position: ['top', 'right'],
        message: "Click on a sample to play and toggle them.",
        el: '#sound-library #sound-list'
      },
      {
        position: ['top', 'right'],
        message: "When a sample is selected, the sampler pads will shake. Click on a shaking sampler pad to put sound on that pad and customize your sampler.",
        el: '#customizing',
        onComplete: () => {
          state.isSoundLibraryOpen = false
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      },
      {
        position: ['top', 'right'],
        message: "You can also record your own samples.",
        el: '#open-recording',
        onComplete: () => {
          requestMic()
            .then(() => {
              state.isSoundLibraryOpen = false
              state.isRecordingOpen = true
              emitter.emit('render')
            })
            .catch(() => {
              emitter.emit('canceltutorial')
            })
        }
      },
      {
        position: ['top', 'left'],
        message: `Click and hold the RECORD button to capture a sample.`,
        el: '#hold-to-record'
      },
      {
        position: ['top', 'left'],
        message: `Press the TEST button to see how it sounds.`,
        el: '#press-to-test'
      },
      {
        position: ['top', 'left'],
        message: `Click on the wave form to start your sample from there.`,
        el: '#wave-preview'
      },
      {
        position: ['top', 'left'],
        message: `When you like how it sounds, give your sample a name and save it to your sample library.`,
        el: '#recording'
      },
      {
        position: ['top', 'right'],
        message: `You are done! Watch <a target="_blank" href="https://www.youtube.com/playlist?list=PLsLn-z-aUeuaLKDAgNLu6L9w423D8P8gH">videos</a> for more tricks and tips!`,
        el: '#sampler-board',
        onComplete: () => {
          state.isSoundLibraryOpen = false
          state.isRecordingOpen = false
          emitter.emit('render')
        }
      }
    ]
    emitter.emit('render')
  })

  emitter.on('nexttutorial', () => {
    console.log('nexttutorial')
    if (state.tutorialSteps[0]) {
      if (state.tutorialSteps[0].onComplete) {
        state.tutorialSteps[0].onComplete()
        // Wait until transition animation ends
        setTimeout(() => {
          state.tutorialSteps.shift()
          emitter.emit('render')
        }, 250)
      } else {
        state.tutorialSteps.shift()
        emitter.emit('render')
      }
    }
    emitter.emit('unfocus')
  })

  emitter.on('canceltutorial', () => {
    console.log('canceltutorial')
    state.tutorialSteps = []
    emitter.emit('render')
  })
};
